module.exports = __webpack_public_path__ + "img/ErekleInashvili.340afa97.webp";